const BRAND_MERCHANT_STATUSES = {
  active: { name: "active", id: "active" },
  disabled: { name: "disabled", id: "disabled" },
};

export default BRAND_MERCHANT_STATUSES;
